import { parseChatChart, chatChartToSuperChartProps } from "./chat-chart-transform"
import SuperChart from "./graphs/SuperChart"
import { useHakiChartColors } from "~/constants/colors"

interface ChatChartBlockProps {
  raw?: string
  validated?: unknown
  /** Drop the outer card chrome and the chart's internal title. */
  bare?: boolean
}

export default function ChatChartBlock({ raw, validated, bare }: ChatChartBlockProps) {
  const hakiChartColors = useHakiChartColors()
  const chart = validated
    ? (validated as {
        type: "bar" | "line" | "area" | "pie"
        title?: string
        series: {
          name: string
          yAxis?: 0 | 1
          data: { label: string; value: number }[]
        }[]
        showTrend?: boolean
      })
    : raw
      ? parseChatChart(raw)
      : null

  if (!chart) {
    return (
      <pre className="overflow-x-auto rounded-lg bg-medium p-3 text-xs">
        <code>{raw ?? "Invalid chart data"}</code>
      </pre>
    )
  }

  const props = chatChartToSuperChartProps(bare ? { ...chart, title: "" } : chart, hakiChartColors)

  if (bare) return <SuperChart {...props} />

  return (
    <div className="my-2 rounded-lg bg-medium p-2">
      <SuperChart {...props} />
    </div>
  )
}
